export interface AutocompleteOption {
  key: string;
  value: string;
}

export function parseToAutocompleteOption(
  selectedOption?: AutocompleteOption | string | undefined,
): AutocompleteOption {
  if (typeof selectedOption === 'string') {
    return { key: selectedOption, value: selectedOption };
  }
  return { key: selectedOption?.key || '', value: selectedOption?.value || '' };
}

export function parseToAutocompleteOptionArray(options: string[]): AutocompleteOption[] {
  return Array.from(new Set(options))?.map((option: string, index: number) => ({
    key: `${option}-${index}`,
    value: option.toUpperCase(),
  }));
}
